<template>
  <div>
    <vx-card class="vx-col w-full mb-base m-auto">
      <form-wizard
        color="rgba(var(--vs-primary), 1)"
        errorColor="rgba(var(--vs-danger), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="Save"
        class="mb-10"
      >
        <tab-content title="Company Info" :before-change="validateStep1">
          <form @submit.prevent data-vv-scope="company" autocomplete="off">
            <div class="vx-row mt-5">
              <div class="vx-col form-group w-full">
                <label class="label">
                  Organisation Name
                  <span class="text-danger">*</span>
                </label>
                <vs-input
                  type="text"
                  class="w-full"
                  v-validate="'required|alpha_spaces|max:50'"
                  name="name"
                  v-model="name"
                />
                <span class="text-danger text-sm">{{ errors.first('company.name') }}</span>
              </div>
              <div class="vx-col  form-group w-full">
                <label class="label">
                  Organisation URL
                  <span class="text-danger">*</span>
                </label>
                <vs-input
                  type="text"
                  class="w-full"
                  v-validate="{url: {require_protocol: false },required:true}"
                  name="url"
                  v-model="url"
                />
                <span class="text-danger text-sm">{{ errors.first('company.url') }}</span>
              </div>
              <div class="vx-col mb-4 md:w-1/3 form-group w-full">
                <label class="label">
                  Industry
                  <span class="text-danger">*</span>
                </label>
                <!-- <vs-input
                  type="text"
                  class="w-full"
                  v-validate="'required|alpha_spaces|max:50'"
                  name="industry"
                  v-model="industry"
                /> -->
                  <!-- <v-select
                    class="w-full"
                    label="text"
                    :options="industriesOption"
                    :reduce="industriesOption => industriesOption.value"
                     v-validate="'required'"
                    v-model="industry"
                    name="industry"
                  ></v-select> -->
                    <vs-select
                  autocomplete
                  class="w-full"
                  v-validate="'required'"
                  name="industry"
                  v-model="industry"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item,index) in industriesOption"
                  />
                </vs-select>
                <span class="text-danger text-sm">{{ errors.first('company.industry') }}</span>
              </div>
              <div class="vx-col mb-4 md:w-1/3 form-group w-full">
                <label class="label">
                  Timezone <span class="text-danger">*</span>
                </label>
                <vs-select
                  class="w-full"
                  v-validate="'required'"
                  name="org_timezone"
                  v-model="org_timezone"
                  autocomplete
                >
                  <vs-select-item
                    :key="index"
                    :value="item.timezone"
                    :text="item.display +' '+item.name"
                    v-for="(item,index) in allTimezone"
                  />
                </vs-select>
                <span class="text-danger text-sm">{{ errors.first('company.org_timezone') }}</span>
              </div>
              <div class="vx-col mb-4 md:w-1/3 form-group w-full">
                <vs-input
                  class="w-full"
                  label="No of Users"
                  v-validate="'numeric|max:5'"
                  name="no_of_employees"
                  v-model="no_of_employees"
                />
                <span class="text-danger text-sm">{{ errors.first('company.no_of_employees') }}</span>
              </div>
            </div>
            <div class="vx-row w-full">
              <div class="vx-col w-full mt-2 mb-2">
                <feather-icon icon="MapPinIcon" class="inline-block mr-2" svgClasses />Address
              </div>
              <div class="vx-col sm: w-full md:w-1/3">
                <label class="label">
                  Address Line 1
                  <span class="text-danger">*</span>
                </label>
                <vs-input
                  type="text"
                  class="w-full"
                  v-validate="'required'"
                  name="address_line_1"
                  v-model="address_line_1"
                />
                <span class="text-danger text-sm">{{ errors.first('company.address_line_1') }}</span>
              </div>
                  <div class="vx-col sm: w-full md:w-1/3 mb-4">
                <label class="label">
                  State
                  <span class="text-danger">*</span>
                </label>
                <vs-select
                  autocomplete
                  class="w-full"
                  v-validate="'required'"
                  name="state"
                  v-model="state"
                  @input="isCountryChanged = true"
                  v-if="country=='Australia'"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.code"
                    :text="item.name"
                    v-for="(item,index) in statesOptions"
                  />
                </vs-select>
                <vs-input
                  type="text"
                  class="w-full"
                  name="state"
                  v-validate="'required'"
                  v-model="state"
                  v-if="country !='Australia'"
                />
                <span class="text-danger text-sm">{{ errors.first('company.state') }}</span>
              </div>
               <div class="vx-col sm: w-full md:w-1/3 mb-4">
                <label class="label">
                  City
                  <span class="text-danger">*</span>
                </label>
                <vs-input
                  type="text"
                  class="w-full"
                  name="city"
                  v-validate="'required'"
                  v-model="city"
                />
                <span class="text-danger text-sm">{{ errors.first('company.city') }}</span>
              </div>
              <!-- <div class="vx-col sm: w-full md:w-1/3 mb-4">
                <vs-input
                  type="text"
                  class="w-full"
                  label="Address Line 2"
                  name="address_line_2"
                  v-model="address_line_2"
                />
              </div> -->
              <div class="vx-col sm: w-full md:w-1/3 mb-4">
                <label class="label">
                  Postcode
                  <span class="text-danger">*</span>
                </label>
                <vs-input
                  type="text"
                  class="w-full"
                  name="post_code"
                  v-validate="'required'"
                  v-model="post_code"
                />
                <span class="text-danger text-sm">{{ errors.first('company.post_code') }}</span>
              </div>
             
          
              <div class="vx-col sm: w-full md:w-1/3 mb-4">
                <label class="label">
                  Country
                  <span class="text-danger">*</span>
                </label>
                <vs-select
                  autocomplete
                  class="w-full"
                  v-validate="'required'"
                  name="country"
                  v-model="country"
                  @input="isCountryChanged = true,state=null"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.name"
                    :text="item.name"
                    v-for="(item,index) in countriesOptions"
                  />
                </vs-select>
                <span class="text-danger text-sm">{{ errors.first('company.country') }}</span>
              </div>
            </div>
          </form>
        </tab-content>
        <tab-content title="Date & Time" :before-change="validateStep2">
          <form class="w-full mt-5" autocomplete="off" data-vv-scope="date-time">
            <div class="vx-row mb-2">
              <div class="vx-col md:w-1/2 form-group w-full">
                <label class="label">
                  Week Start Day
                  <span class="text-danger">*</span>
                </label>
                <vs-select
                  class="w-full"
                  v-validate="'required'"
                  name="startDay"
                  v-model="startDay"
                  placeholder="Week Start Day"
                  autocomplete
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-if="item.value !== endDay"
                    v-for="(item,index) in dayList"
                  />
                </vs-select>
                <span class="text-danger text-sm">{{ errors.first('date-time.startDay') }}</span>
              </div>
              <div class="vx-col md:w-1/2 form-group w-full">
                <label class="label">
                  Week End Day
                  <span class="text-danger">*</span>
                </label>
                <vs-select
                  autocomplete
                  class="w-full"
                  v-validate="'required'"
                  name="endDay"
                  v-model="endDay"
                  placeholder="Week End Day"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-if="item.value !== startDay"
                    v-for="(item,index) in dayList"
                  />
                </vs-select>
                <span class="text-danger text-sm">{{ errors.first('date-time.endDay') }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 form-group w-full">
                <label class="label">
                  Start Time
                  <span class="text-danger">*</span>
                </label>
                <flat-pickr
                  class="vs-inputx vs-input--input normal time"
                  v-validate="'required'"
                  name="startTime"
                  :config="configdateTimePicker"
                  v-model="startTime"
                  placeholder="Start Time"
                  @input="getWorkingHours()"
                />
                <span class="text-danger text-sm">{{ errors.first('date-time.startTime') }}</span>
              </div>
              <div class="vx-col md:w-1/2 form-group w-full">
                <label class="label">
                  End Time
                  <span class="text-danger">*</span>
                </label>
                <flat-pickr
                  class="vs-inputx vs-input--input normal time"
                  v-validate="'required'"
                  name="endTime"
                  :config="configendDateTimePicker"
                  v-model="endTime"
                  placeholder="End Time"
                  @input="getWorkingHours()"
                />
                <span class="text-danger text-sm">{{ errors.first('date-time.endTime') }}</span>
              </div>
              <div class="vx-col md:w-1/2 form-group w-full mt-4">
                <label class="label">
                  Standard Lunch Break
                </label>
                  <vs-input
                  type="text"
                  class="w-full"
                  name="break_hours"
                  v-model="break_hours"
                  v-validate="'decimal:2'"
                  @input="getWorkingHours()"
                />
                <!-- <flat-pickr
                  class="vs-inputx vs-input--input normal time"
                  v-validate="'required'"
                  name="break_hours"
                  :config="configendHoursPicker"
                  v-model="break_hours"
                  placeholder="00 hr 00 m"
                /> -->
                <span class="text-danger text-sm">{{ errors.first('date-time.break_hours') }}</span>
                <!-- parent div class = 'standard-time'
                  <span
                  v-if="break_hours"
                  class="mr-2"
                >{{ break_hours.split(":")[0] + " hr " + break_hours.split(":")[1] + " m " }}</span> -->
                <!-- <span class="mr-2" v-else>00 hr 00 m</span>Standard Lunch Break -->
              </div>
              <div class="vx-col md:w-1/2 form-group w-full mt-4">
                <label class="label">
                  Standard Working Hours
               
                </label>
                <!-- <flat-pickr
                  :disabled="true"
                  class="vs-inputx vs-input--input normal time"
                  v-validate="'required'"
                  name="working_hours"
                  :config="configendHoursPicker"
                  v-model="working_hours"
                  placeholder="00 hr 00 m"
                /> -->
                 <vs-input
                  type="text"
                  class="w-full"
                   :disabled="true"
                  name="working_hours"
                  v-model="working_hours"
                  @input="getWorkingHours()"
                  placeholder="00 hr 00 m"
                />
                <span class="text-danger text-sm">{{ errors.first('date-time.working_hours') }}</span>
                <!-- parent div class = 'standard-time'
                  <span
                  v-if="working_hours"
                  class="mr-2"
                >{{ working_hours.split(":")[0] + " hr " + working_hours.split(":")[1] + " m "}}</span>
                <span class="mr-2" v-else>00 hr 00 m</span>Standard Working Hours -->
              </div>
              <div class="vx-col md:w-1/2 form-group w-full">
                <label class="label">
                  Auto Clock Off Hours
                  <span class="text-danger">*</span>
                </label>
                <vs-select
                  autocomplete
                  class="w-full"
                  name="autoClockOff"
                  v-model="autoClockOff"
                  placeholder="Auto Clock Off"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item,index) in hourList"
                  />
                </vs-select>
                <span class="text-danger text-sm">{{ errors.first('date-time.autoClockOff') }}</span>
              </div>
              <div class="vx-col w-full">
                <h4 class="vx-col w-full mt-5 mb-2 bodbot">Manage Holidays</h4>

                <form
                  autocomplete="off"
                  data-vv-scope="holiday-form"
                  class="vx-row mb-2"
                >
                  <div class="vx-col md:w-1/3 form-group w-full">
                    <label class="label">
                      Title
                    </label>
                    <vs-input
                      class="w-full"
                      v-validate="'required|alpha_name_cots|max:50'"
                      name="title"
                      v-model="title"
                    />
                    <span
                      v-show="errors.has('holiday-form.title')"
                      class="text-danger text-sm"
                    >{{ errors.first('holiday-form.title') }}</span>
                  </div>
                  <div class="vx-col md:w-1/3 form-group w-full">
                    <label class="label">
                      Holiday Date
                    </label>
                    <datepicker class="calendar-icon-right" :calendar-button="true" calendar-button-icon="fa fa-calendar" v-model="holidayDate" v-validate="'required'" name="holidayDate"></datepicker>

                    <span
                      v-show="errors.has('holiday-form.holidayDate')"
                      class="text-danger text-sm"
                    >{{ errors.first('holiday-form.holidayDate') }}</span>
                  </div>

                  <div class="vx-col md:w-1/3 form-group w-full">
                    <vs-button
                      class="m-auto mt-6 mr-5 gradient-btn"
                      @click.prevent="addHoliday()"
                      id="data-addupdate1"
                    >{{holidayId ? 'Edit' : 'Add'}}</vs-button>
                  </div>
                </form>
                <div class="vx-col md:w-1/1 sm:w-1/1 xs:w-1/1 w-full">
                  <vs-table :data="holidays" class="mt-1" style="position: sticky;">
                    <template slot="thead">
                      <vs-th>Title</vs-th>
                      <vs-th>Date</vs-th>
                      <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>{{ tr.title }}</vs-td>
                        <vs-td>{{ getConvertedDate(tr.date) }}</vs-td>
                        <vs-td>
                          <vs-button
                            color=" #F4B400"
                            type="filled"
                            class="mr-2 mb-2 float-left"
                            icon-pack="feather"
                            icon="icon-edit-2"
                            size="small"
                            title="Edit Holiday"
                            @click.prevent="editHoliday(indextr)"
                          ></vs-button>
                          <vs-button
                            color="#DB4437"
                            type="filled"
                            icon-pack="feather"
                            icon="icon-trash-2"
                            size="small"
                            title="Delete Holiday"
                            @click.prevent="confirmDelete(indextr)"
                          ></vs-button>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </div>
            <!-- <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-button
                  class="mt-1 m-auto gradient-btn"
                  @click.prevent="addUpdateData()"
                  :disabled="button_loading"
                  id="data-addupdate"
                >{{ DataIndex ? 'Save' : 'Save' }}</vs-button>
                <vs-button class="mt-1 ml-4 m-auto gradient-btn" @click.prevent="cancelDt()">Cancel</vs-button>
              </div>
            </div> -->
          </form>
        </tab-content>
        <tab-content title="Admin Contact" :before-change="validateStep3">
          <form data-vv-scope="admin-contact" autocomplete="off">
            <div class="vx-row mt-5">
              <div class="vx-col md:w-1/2 form-group w-full">
                <label class="label">
                  Contact Person First Name
                  <span class="text-danger">*</span>
                </label>
                <vs-input
                  class="w-full"
                  v-validate="'required|alpha_spaces|max:25'"
                  name="first_name"
                  v-model="firstName"
                  type="text"
                />
                <span class="text-danger text-sm">{{ errors.first('admin-contact.first_name') }}</span>
              </div>
              <div class="vx-col md:w-1/2 form-group w-full">
                <label class="label">
                  Contact Person Last Name
                  <span class="text-danger">*</span>
                </label>
                <vs-input
                  class="w-full"
                  v-validate="'required|alpha_spaces|max:25'"
                  name="last_name"
                  v-model="lastName"
                  type="text"
                />
                <span class="text-danger text-sm">{{ errors.first('admin-contact.last_name') }}</span>
              </div>
              <div class="vx-col md:w-1/2 form-group w-full">
                <label class="label">
                  Email
                  <span class="text-danger">*</span>
                </label>
                <vs-input
                  class="w-full"
                  v-validate="'required|email'"
                  name="email"
                  v-model="email"
                  type="email"
                  :disabled="true"
                />
                <span class="text-danger text-sm">{{ errors.first('admin-contact.email') }}</span>
              </div>
              <div class="vx-col md:w-1/2 form-group w-full">
                <label class="label">
                  Phone
                  
                </label>
                <vs-input
                  class="w-full"
                  v-validate="'numeric|min:10|max:10'"
                  name="phone"
                  v-model="phone"
                  type="number"
                  @keydown="filterKey"
                />
                <span class="text-danger text-sm">{{ errors.first('admin-contact.phone') }}</span>
              </div>
            </div>
          </form>
        </tab-content>
        <tab-content title="Logo" :before-change="validateStep4">
          <form class="w-full mt-5" autocomplete="off" data-vv-scope="logo">
            <h4>Upload a custom Logo</h4>
            <hr />
            <p
              class="mb-4 mt-4"
            >Uploaded files will display in the upper left-hand corner of your SIO web dashboard</p>
            <div class="mt-5" v-if="!logo">
              <vue-image-upload
                field="img"
                @crop-success="cropSuccess"
                v-model="show_image_popup"
                v-validate="'required'"
                name="image"
                :width="400"
                :height="400"
                lang-type="en"
                img-format="png"
                :no-rotate="false"
                :no-circle="true"
                :no-square="false"
              ></vue-image-upload>
              <vs-button
                color="primary"
                @click.prevent="pickFile()"
                id="upload-profile-button"
                class="mb-5"
              >Choose File</vs-button>
              <span class="text-danger text-sm">{{ errors.first('image') }}</span>
            </div>
            <div class="w-full float-left" v-else>
              <div class="img-upload" v-if="logo">
                <img
                  class="mr-2 mb-4"
                  :src="logo"
                  style="width: 140px; max-height: 140px; float:left;"
                />
                <vs-button
                  class="mt-2"
                  size="small"
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="removeLogo()"
                ></vs-button>
              </div>
            </div>
            <div class="w-full">
              <p>
                Recommended file type
                <b>png / jpg</b>
              </p>
              <p>
                Recommended file size :
                <b>400 x 400 pixels</b>
              </p>
            </div>
          </form>
        </tab-content>
      </form-wizard>
    </vx-card>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Datepicker from "vuejs-datepicker";
import VueImageUpload from "vue-image-crop-upload";
import timeZone from "@/mixins/timezone.js";
import vSelect from "vue-select";
import moment from "moment";
import { EventBus } from '@/mixins/mixin.js';

import { Validator } from "vee-validate";
const dict = {
  custom: {
    name: {
      required: "Please enter name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Organisation name should not be greater than 50 characters"
    },
    url: {
      required: "Please enter organisation URL",
      url: "Please enter valid URL"
    },
    contact_person_name: {
      required: "Please enter contact person name",
      alpha_spaces: "Only alphabetic characters and space allowed"
    },
    first_name: {
      required: "Please enter first name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "First name should not be greater than 25 characters"
    },
    last_name: {
      required: "Please enter last name",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Last name should not be greater than 25 characters"
    },
    email: {
      required: "Please enter email",
      email: "Please enter valid email"
    },
    address_line_1: {
      required: "Please enter address"
    },
    post_code: {
      required: "Please enter post code"
    },
    phone: {
      required: "Please enter phone number",
      numeric: "Please enter valid number",
      min: "Phone number must be at least 10 digits",
      max: "Phone number may not be greater than 10 digits"
    },
    password: {
      required: "Please enter password",
      min: "Password should be minimum 6 characters",
      verify_password:
        "Password should be minimum 8 characters : 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character (E.g. , . _ & ? etc)"
    },
    password_confirmation: {
      required: "Please enter confirm password",
      confirmed: "Password and confirm password should be same"
    },
    role: {
      required: "Please select user role"
    },
    city: {
      required: "Please enter city name"
    },
    state: {
      required: "Please enter state name"
    },
    country: {
      required: "Please enter country name"
    },
    industry: {
      required: "Please enter industry name"
    },
    designation: {
      required: "Please enter user designation",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Designation not be greater than 25 characters"
    },
    no_of_employees: {
      required: "Please enter no of employees",
      numeric: "Please enter valid number",
      max: "Employees may not be greater than 5 digits"
    },
    no_of_department: {
      required: "Please enter no of department",
      numeric: "Please enter valid number",
      max: "Number of department may not be greater than 2 digits"
    },
    no_of_locations: {
      required: "Please enter no of location",
      numeric: "Please enter valid number",
      max: "Number of location may not be greater than 2 digits"
    },
    no_of_vehicles: {
      required: "Please enter no of vehicles",
      numeric: "Please enter valid number",
      max: "Vehicles may not be greater than 5 digits"
    },
    org_timezone: {
      required: "Please select timezone"
    },
    startDay: {
      required: "Please select start day"
    },
    endDay: {
      required: "Please select end day"
    },
    startTime: {
      required: "Please select start time"
    },
    endTime: {
      required: "Please select end time"
    },
    title: {
      required: "Please enter title",
      alpha_spaces: "Only alphabetic characters and space allowed",
      max: "Title name not be greater than 50 characters"
    },
    holidayDate: {
      required: "Please select date"
    },
    break_hours: {
      required: "Please select break hours"
    },
    working_hours: {
      required: "Please select working hours"
    }
  }
};
Validator.localize("en", dict);
export default {
  components: {
    vSelect,
    Datepicker,
    FormWizard,
    TabContent,
    "vue-image-upload": VueImageUpload,
    EventBus
  },
  data() {
    return {
      tab: 0,
      deleteIndex: null,
      //logo
      logo: "",
      show_image_popup: false,
      logo_update: false,
      editLogo: null,
      //company info

      name: "",
      url: "",
      org_timezone: "",
      allTimezone: timeZone.data,
      no_of_employees: "",

      //date & time
      startDay: "Mo",
      endDay: "Fr",
      autoClockOff:1,
      hourList:[
        { text: "01:00", value: "01:00" },
        { text: "02:00", value: "02:00" },
        { text: "03:00", value: "03:00" },
        { text: "04:00", value: "04:00" },
        { text: "05:00", value: "05:00" },
        { text: "06:00", value: "06:00" },
        { text: "07:00", value: "07:00" },
        { text: "08:00", value: "08:00" },
        { text: "09:00", value: "09:00" },
        { text: "10:00", value: "10:00" },

      ],
      dayList: [
        { text: "Sunday", value: "Su" },
        { text: "Monday", value: "Mo" },
        { text: "Tuesday", value: "Tu" },
        { text: "Wednesday", value: "We" },
        { text: "Thursday", value: "Th" },
        { text: "Friday", value: "Fr" },
        { text: "Saturday", value: "Sa" }
      ],
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        dateFormat: "H:i"
      },
      configendDateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        dateFormat: "H:i"
      },
      configendHoursPicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        dateFormat: "H:i"
      },
      configdateDatePicker: {
        inline: true
      },
      startTime: null,
      endTime: null,
      holidayId: null,
      title: null,
      holidayDate: null,
      DataIndex: null,
      holidays: [],
      firstName: null,
      lastName: null,
      email: null,
      phone: null,
      industry: null,
      working_hours: null,
      break_hours: null,
      city: null,
      state: null,
      post_code: null,
      address_line_1: null,
      address_line_2: null,
      country: null,
      countryOption:[
        {value:"Australia", text:"Australia"},
        {value:"New Zealand", text:"New Zealand"},
        {value:"United States", text:"United States"},
        {value:"United Kingdom", text:"United Kingdom"},
        {value:"Canada", text:"Canada"},
        {value:"Afghanistan", text:"Afghanistan"},
        {value:"Åland Islands", text:"Åland Islands"},
        {value:"Albania", text:"Albania"},
        {value:"Algeria", text:"Algeria"},
        {value:"American Samoa", text:"American Samoa"},
        {value:"Andorra", text:"Andorra"},
        {value:"Angola", text:"Angola"},
        {value:"Anguilla", text:"Anguilla"},
        {value:"Antarctica", text:"Antarctica"},
        {value:"Antigua and Barbuda", text:"Antigua and Barbuda"},
        {value:"Argentina", text:"Argentina"},
        {value:"Armenia", text:"Armenia"},
        {value:"Aruba", text:"Aruba"},
        {value:"Austria", text:"Austria"},
        {value:"Azerbaijan", text:"Azerbaijan"},
        {value:"Bahamas", text:"Bahamas"},
        {value:"Bahrain", text:"Bahrain"},
        {value:"Bangladesh", text:"Bangladesh"},
        {value:"Barbados", text:"Barbados"},
        {value:"Belarus", text:"Belarus"},
        {value:"Belgium", text:"Belgium"},
        {value:"Belize", text:"Belize"},
        {value:"Benin", text:"Benin"},
        {value:"Bermuda", text:"Bermuda"},
        {value:"Bhutan", text:"Bhutan"},
        {value:"Bolivia", text:"Bolivia"},
        {value:"Bosnia and Herzegovina", text:"Bosnia and Herzegovina"},
        {value:"Botswana", text:"Botswana"},
        {value:"Bouvet Island", text:"Bouvet Island"},
        {value:"Brazil", text:"Brazil"},
        {value:"British Indian Ocean Territory", text:"British Indian Ocean Territory"},
        {value:"Brunei Darussalam", text:"Brunei Darussalam"},
        {value:"Bulgaria", text:"Bulgaria"},
        {value:"Burkina Faso", text:"Burkina Faso"},
        {value:"Burundi", text:"Burundi"},
        {value:"Cambodia", text:"Cambodia"},
        {value:"Cameroon", text:"Cameroon"},
        {value:"Cape Verde", text:"Cape Verde"},
        {value:"Cayman Islands", text:"Cayman Islands"},
        {value:"Central African Republic", text:"Central African Republic"},
        {value:"Chad", text:"Chad"},
        {value:"Chile", text:"Chile"},
        {value:"China", text:"China"},
        {value:"Christmas Island", text:"Christmas Island"},
        {value:"Cocos (Keeling) Islands", text:"Cocos (Keeling) Islands"},
        {value:"Colombia", text:"Colombia"},
        {value:"Comoros", text:"Comoros"},
        {value:"Congo", text:"Congo"},
        {value:"Congo, The Democratic Republic of The", text:"Congo, The Democratic Republic of The"},
        {value:"Cook Islands", text:"Cook Islands"},
        {value:"Costa Rica", text:"Costa Rica"},
        {value:"Cote D'ivoire", text:"Cote D'ivoire"},
        {value:"Croatia", text:"Croatia"},
        {value:"Cuba", text:"Cuba"},
        {value:"Cyprus", text:"Cyprus"},
        {value:"Czech Republic", text:"Czech Republic"},
        {value:"Denmark", text:"Denmark"},
        {value:"Djibouti", text:"Djibouti"},
        {value:"Dominica", text:"Dominica"},
        {value:"Dominican Republic", text:"Dominican Republic"},
        {value:"Ecuador", text:"Ecuador"},
        {value:"Egypt", text:"Egypt"},
        {value:"El Salvador", text:"El Salvador"},
        {value:"Equatorial Guinea", text:"Equatorial Guinea"},
        {value:"Eritrea", text:"Eritrea"},
        {value:"Estonia", text:"Estonia"},
        {value:"Ethiopia", text:"Ethiopia"},
        {value:"Falkland Islands (Malvinas)", text:"Falkland Islands (Malvinas)"},
        {value:"Faroe Islands", text:"Faroe Islands"},
        {value:"Fiji", text:"Fiji"},
        {value:"Finland", text:"Finland"},
        {value:"France", text:"France"},
        {value:"French Guiana", text:"French Guiana"},
        {value:"French Polynesia", text:"French Polynesia"},
        {value:"French Southern Territories", text:"French Southern Territories"},
        {value:"Gabon", text:"Gabon"},
        {value:"Gambia", text:"Gambia"},
        {value:"Georgia", text:"Georgia"},
        {value:"Germany", text:"Germany"},
        {value:"Ghana", text:"Ghana"},
        {value:"Gibraltar", text:"Gibraltar"},
        {value:"Greece", text:"Greece"},
        {value:"Greenland", text:"Greenland"},
        {value:"Grenada", text:"Grenada"},
        {value:"Guadeloupe", text:"Guadeloupe"},
        {value:"Guam", text:"Guam"},
        {value:"Guatemala", text:"Guatemala"},
        {value:"Guernsey", text:"Guernsey"},
        {value:"Guinea", text:"Guinea"},
        {value:"Guinea-bissau", text:"Guinea-bissau"},
        {value:"Guyana", text:"Guyana"},
        {value:"Haiti", text:"Haiti"},
        {value:"Heard Island and Mcdonald Islands", text:"Heard Island and Mcdonald Islands"},
        {value:"Holy See (Vatican City State)", text:"Holy See (Vatican City State)"},
        {value:"Honduras", text:"Honduras"},
        {value:"Hong Kong", text:"Hong Kong"},
        {value:"Hungary", text:"Hungary"},
        {value:"Iceland", text:"Iceland"},
        {value:"India", text:"India"},
        {value:"Indonesia", text:"Indonesia"},
        {value:"Iran, Islamic Republic of", text:"Iran, Islamic Republic of"},
        {value:"Iraq", text:"Iraq"},
        {value:"Ireland", text:"Ireland"},
        {value:"Isle of Man", text:"Isle of Man"},
        {value:"Israel", text:"Israel"},
        {value:"Italy", text:"Italy"},
        {value:"Jamaica", text:"Jamaica"},
        {value:"Japan", text:"Japan"},
        {value:"Jersey", text:"Jersey"},
        {value:"Jordan", text:"Jordan"},
        {value:"Kazakhstan", text:"Kazakhstan"},
        {value:"Kenya", text:"Kenya"},
        {value:"Kiribati", text:"Kiribati"},
        {value:"Korea, Democratic People's Republic of", text:"Korea, Democratic People's Republic of"},
        {value:"Korea, Republic of", text:"Korea, Republic of"},
        {value:"Kuwait", text:"Kuwait"},
        {value:"Kyrgyzstan", text:"Kyrgyzstan"},
        {value:"Lao People's Democratic Republic", text:"Lao People's Democratic Republic"},
        {value:"Latvia", text:"Latvia"},
        {value:"Lebanon", text:"Lebanon"},
        {value:"Lesotho", text:"Lesotho"},
        {value:"Liberia", text:"Liberia"},
        {value:"Libyan Arab Jamahiriya", text:"Libyan Arab Jamahiriya"},
        {value:"Liechtenstein", text:"Liechtenstein"},
        {value:"Lithuania", text:"Lithuania"},
        {value:"Luxembourg", text:"Luxembourg"},
        {value:"Macao", text:"Macao"},
        {value:"Macedonia, The Former Yugoslav Republic of", text:"Macedonia, The Former Yugoslav Republic of"},
        {value:"Madagascar", text:"Madagascar"},
        {value:"Malawi", text:"Malawi"},
        {value:"Malaysia", text:"Malaysia"},
        {value:"Maldives", text:"Maldives"},
        {value:"Mali", text:"Mali"},
        {value:"Malta", text:"Malta"},
        {value:"Marshall Islands", text:"Marshall Islands"},
        {value:"Martinique", text:"Martinique"},
        {value:"Mauritania", text:"Mauritania"},
        {value:"Mauritius", text:"Mauritius"},
        {value:"Mayotte", text:"Mayotte"},
        {value:"Mexico", text:"Mexico"},
        {value:"Micronesia, Federated States of", text:"Micronesia, Federated States of"},
        {value:"Moldova, Republic of", text:"Moldova, Republic of"},
        {value:"Monaco", text:"Monaco"},
        {value:"Mongolia", text:"Mongolia"},
        {value:"Montenegro", text:"Montenegro"},
        {value:"Montserrat", text:"Montserrat"},
        {value:"Morocco", text:"Morocco"},
        {value:"Mozambique", text:"Mozambique"},
        {value:"Myanmar", text:"Myanmar"},
        {value:"Namibia", text:"Namibia"},
        {value:"Nauru", text:"Nauru"},
        {value:"Nepal", text:"Nepal"},
        {value:"Netherlands", text:"Netherlands"},
        {value:"Netherlands Antilles", text:"Netherlands Antilles"},
        {value:"New Caledonia", text:"New Caledonia"},
        {value:"Nicaragua", text:"Nicaragua"},
        {value:"Niger", text:"Niger"},
        {value:"Nigeria", text:"Nigeria"},
        {value:"Niue", text:"Niue"},
        {value:"Norfolk Island", text:"Norfolk Island"},
        {value:"Northern Mariana Islands", text:"Northern Mariana Islands"},
        {value:"Norway", text:"Norway"},
        {value:"Oman", text:"Oman"},
        {value:"Pakistan", text:"Pakistan"},
        {value:"Palau", text:"Palau"},
        {value:"Palestinian Territory, Occupied", text:"Palestinian Territory, Occupied"},
        {value:"Panama", text:"Panama"},
        {value:"Papua New Guinea", text:"Papua New Guinea"},
        {value:"Paraguay", text:"Paraguay"},
        {value:"Peru", text:"Peru"},
        {value:"Philippines", text:"Philippines"},
        {value:"Pitcairn", text:"Pitcairn"},
        {value:"Poland", text:"Poland"},
        {value:"Portugal", text:"Portugal"},
        {value:"Puerto Rico", text:"Puerto Rico"},
        {value:"Qatar", text:"Qatar"},
        {value:"Reunion", text:"Reunion"},
        {value:"Romania", text:"Romania"},
        {value:"Russian Federation", text:"Russian Federation"},
        {value:"Rwanda", text:"Rwanda"},
        {value:"Saint Helena", text:"Saint Helena"},
        {value:"Saint Kitts and Nevis", text:"Saint Kitts and Nevis"},
        {value:"Saint Lucia", text:"Saint Lucia"},
        {value:"Saint Pierre and Miquelon", text:"Saint Pierre and Miquelon"},
        {value:"Saint Vincent and The Grenadines", text:"Saint Vincent and The Grenadines"},
        {value:"Samoa", text:"Samoa"},
        {value:"San Marino", text:"San Marino"},
        {value:"Sao Tome and Principe", text:"Sao Tome and Principe"},
        {value:"Saudi Arabia", text:"Saudi Arabia"},
        {value:"Senegal", text:"Senegal"},
        {value:"Serbia", text:"Serbia"},
        {value:"Seychelles", text:"Seychelles"},
        {value:"Sierra Leone", text:"Sierra Leone"},
        {value:"Singapore", text:"Singapore"},
        {value:"Slovakia", text:"Slovakia"},
        {value:"Slovenia", text:"Slovenia"},
        {value:"Solomon Islands", text:"Solomon Islands"},
        {value:"Somalia", text:"Somalia"},
        {value:"South Africa", text:"South Africa"},
        {value:"South Georgia and The South Sandwich Islands", text:"South Georgia and The South Sandwich Islands"},
        {value:"Spain", text:"Spain"},
        {value:"Sri Lanka", text:"Sri Lanka"},
        {value:"Sudan", text:"Sudan"},
        {value:"Suriname", text:"Suriname"},
        {value:"Svalbard and Jan Mayen", text:"Svalbard and Jan Mayen"},
        {value:"Swaziland", text:"Swaziland"},
        {value:"Sweden", text:"Sweden"},
        {value:"Switzerland", text:"Switzerland"},
        {value:"Syrian Arab Republic", text:"Syrian Arab Republic"},
        {value:"Taiwan", text:"Taiwan"},
        {value:"Tajikistan", text:"Tajikistan"},
        {value:"Tanzania, United Republic of", text:"Tanzania, United Republic of"},
        {value:"Thailand", text:"Thailand"},
        {value:"Timor-leste", text:"Timor-leste"},
        {value:"Togo", text:"Togo"},
        {value:"Tokelau", text:"Tokelau"},
        {value:"Tonga", text:"Tonga"},
        {value:"Trinidad and Tobago", text:"Trinidad and Tobago"},
        {value:"Tunisia", text:"Tunisia"},
        {value:"Turkey", text:"Turkey"},
        {value:"Turkmenistan", text:"Turkmenistan"},
        {value:"Turks and Caicos Islands", text:"Turks and Caicos Islands"},
        {value:"Tuvalu", text:"Tuvalu"},
        {value:"Uganda", text:"Uganda"},
        {value:"Ukraine", text:"Ukraine"},
        {value:"United Arab Emirates", text:"United Arab Emirates"},
        {value:"United States Minor Outlying Islands", text:"United States Minor Outlying Islands"},
        {value:"Uruguay", text:"Uruguay"},
        {value:"Uzbekistan", text:"Uzbekistan"},
        {value:"Vanuatu", text:"Vanuatu"},
        {value:"Venezuela", text:"Venezuela"},
        {value:"Viet Nam", text:"Viet Nam"},
        {value:"Virgin Islands, British", text:"Virgin Islands, British"},
        {value:"Virgin Islands, U.S.", text:"Virgin Islands, U.S."},
        {value:"Wallis and Futuna", text:"Wallis and Futuna"},
        {value:"Western Sahara", text:"Western Sahara"},
        {value:"Yemen", text:"Yemen"},
        {value:"Zambia", text:"Zambia"},
        {value:"Zimbabwe", text:"Zimbabwe"}
      ],
      industriesOption:[
        { value:"Accounting",text:"Accounting"},
        { value:"Architecture/Planning",text:"Architecture/Planning"},
        { value:"Automotive",text:"Automotive"},
        { value:"Biotechnology/Greentech",text:"Biotechnology/Greentech"},
        { value:"Business Supplies/Equipment",text:"Business Supplies/Equipment"},
        { value:"Construction",text:"Construction"},
        { value:"Education",text:"Education"},
        { value:"Environmental Services",text:"Environmental Services"},
        { value:"Facilities Services",text:"Facilities Services"},
        { value:"Financial Services",text:"Financial Services"},
        { value:"Furniture",text:"Furniture"},
        { value:"Graphic Design/Web Design",text:"Graphic Design/Web Design"},
        { value:"Health/Fitness/Gym",text:"Health/Fitness/Gym"},
        { value:"Health Care",text:"Health Care"},
        { value:"Hospitality",text:"Hospitality"},
        { value:"Hotel",text:"Hotel"},
        { value:"Human Resources",text:"Human Resources"},
        { value:"Import/Export",text:"Import/Export"},
        { value:"Information Technology/IT",text:"Information Technology/IT"},
        { value:"Insurance",text:"Insurance"},
        { value:"Legal Services",text:"Legal Services"},
        { value:"Logistics/Procurement",text:"Logistics/Procurement"},
        { value:"Marketing/Advertising/Sales",text:"Marketing/Advertising/Sales"},
        { value:"Medical Equipment",text:"Medical Equipment"},
        { value:"Medical Practice",text:"Medical Practice"},
        { value:"Mining",text:"Mining"},
        { value:"Motel",text:"Motel"},
        { value:"Museum/Gallery",text:"Museum/Gallery"},
        { value:"Oil/Energy/Solar/Greentech",text:"Oil/Energy/Solar/Greentech"},
        { value:"Packaging",text:"Packaging"},
        { value:"Political Organization",text:"Political Organization"},
        { value:"Printing",text:"Printing"},
        { value:"Real Estate",text:"Real Estate"},
        { value:"Religious ",text:"Religious "},
        { value:"Retail ",text:"Retail "},
        { value:"Safety",text:"Safety"},
        { value:"Sports",text:"Sports"},
        { value:"Telecommunications",text:"Telecommunications"}
      ],
      isCountryChanged:false,
    };
  },
  created() {
    this.getInfo();
    this.getDateTimeData();
  },
  watch: {
   
  },
  mounted() {
    
  },
  methods: {
    getConvertedDate(date){
      return moment.tz(date, this.timezone).format('MMMM Do YYYY');
    },
    getWorkingHours(){
      var timeStart = new Date("01/01/2000 " +  this.startTime);
      var timeEnd = new Date("01/01/2000 " + this.endTime);
      var st = moment.tz(timeStart, this.timezone).valueOf();
      var end = moment.tz(timeEnd, this.timezone).valueOf();
      var working_hours = Math.abs(end - st);
      var minHours = working_hours/(1000*60);
      var breakhr = isNaN(this.break_hours*60)?0:parseFloat(this.break_hours*60);
      const addZero = d => (d > 9 ? d.toString() : "0" + d.toString());
      let hours = addZero(Math.floor((minHours-breakhr) / 60));
      let minutes = addZero((minHours-breakhr) % 60);
      this.working_hours = hours + " hrs " + minutes+" min";
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("company").then(result => {
          if (result) {
            resolve(true);
            if(this.isCountryChanged){
              this.holidays = [];
            }
            if(this.isCountryChanged && this.country =='Australia'){
              this.getHolidayList();
            }
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("date-time").then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep3() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("admin-contact").then(result => {
          if (result) {
            resolve(true);
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep4() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("logo").then(result => {
          if (result) {
            resolve(true);
            this.updateDateTimeData();
            this.updateOrganization();
          } else {
            reject("correct all values");
          }
        });
      });
    },
    removeLogo() {
      this.logo = "";
      this.show_image_popup = false;
    },
    pickFile() {
      this.show_image_popup = !this.show_image_popup;
    },
    cropSuccess(imgDataUrl) {
      this.logo = imgDataUrl;
      this.logo_update = true;
    },
   async getHolidayList(){
    let input = {
      	"id":this.$store.state.uInfo.organization,
        "state":this.state,
        "country":this.country
    };
await this.axios
        .post("organization/updateHolidays", input)
        .then(response => {
          if (response) {
            let data = response.data.data;
            data.forEach((element,index) => {
                this.holidays.push({
                   id: index + 1,
              title: element.title,
              date: element.date
                });
            });
          }
        })
        .catch(e => {
          this.showError(e, "#data-addupdate");
        });
    },
    getInfo() {
      let url =
        "organization/getOne?id=" + this.$store.state.uInfo.organization;
      this.axios
        .get(url)
        .then(response => {
          let org = response.data.data;
          this.city = org.city;
          this.state = org.state;
          this.country = org.country;
          this.industry = org.industry;
          this.address_line_1 = org.address_line1;
          this.address_line_2 = org.address_line2;
          this.post_code = org.pincode;
          this.firstName = org.contact_person.firstname;
          this.lastName = org.contact_person.lastname;
          this.email = org.contact_person.email;
          this.phone = org.contact_person.phone;
          this.password = "###########";
          this.url = org.url;
          this.name = org.name;
          this.designation = org.contact_person.designation;
          this.no_of_employees = org.no_of_employees;
          this.org_timezone = org.time_zone;
          this.logo = org.logo;
          this.editLogo = org.logo;
          if (org.logo) {
            this.logo_update = false;
          }
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        })
        .catch(e => {
          this.showError(e);
        });
    },

    async updateOrganization() {
      // this.$validator.validateAll("company").then(result => {
      //   if (result) {
          this.$vs.loading({ color: "primary" });
          let input = {
            id: this.$store.state.uInfo.organization,
            url: this.url,
            name: this.name,
            no_of_employees: this.no_of_employees,
            time_zone: this.org_timezone,
            industry: this.industry,
            address_line1: this.address_line_1,
            address_line2: this.address_line_2,
            city: this.city,
            state: this.state,
            country: this.country,
            pincode: this.post_code,
            // organization user details
            firstname: this.firstName,
            lastname: this.lastName,
            email: this.email,
            phone: this.phone,
            // update logo
            logo: this.logo,
            logo_update: this.logo_update,
            is_profile_complete: true
          };
          let result = await this.axios
            .put("organization/edit", input)
            .then(response => {
              if (response.data) {
                this.button_loader(false, "#org-addupdate");
                let text = "Company info updated successfully!!!";
                this.$vs.notify({
                  text: text,
                  color: "success",
                  position: "top-right"
                });
                this.getDateTimeData();
                response.data.data.is_profile_complete = true;
                this.$store.dispatch("updateUserDetails", response.data.data);
                EventBus.$emit('menuCHanges');
                this.$vs.loading.close();
                this.$router.push({ name: "organizationManageUsers" });
                return true;
              }
            })
            .catch(e => {
              this.showError(e, "#org-addupdate");
              return false;
            });
          return result;
      //   }
      // });
    },
    async updateDateTimeData() {
      this.$vs.loading({ color: "primary" });
      let input = {
        week_start_day: this.startDay,
        week_end_day: this.endDay,
        working_time_from: this.startTime,
        working_time_to: this.endTime,
        holidays: this.holidays,
        break_hours: this.break_hours,
        working_hours: this.working_hours,
        auto_out_time: this.autoClockOff
      };
      await this.axios
        .post("oinfo/createOrEdit", input)
        .then(response => {
          if (response) {   
            this.button_loader(false, "#data-addupdate");
            let text = "Company date & time updated successfully!!!";
            this.$vs.notify({
              text: text,
              color: "success",
              position: "top-right"
            });
            // this.getDateTimeData();
            this.$vs.loading.close();
            return true;
          }
        })
        .catch(e => {
          this.showError(e, "#data-addupdate");
          return false;
        });
    },
    Cancel() {
      history.back();
    },
    getDateTimeData() {
      this.$vs.loading({ color: "primary" });

      let url = "oinfo/getInfo";
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.DataIndex = data.id;
          this.startDay = data.week_start_day;
          this.endDay = data.week_end_day;
          this.startTime = data.working_time_from;
          this.endTime = data.working_time_to;
          this.holidays = data.holidays;
          this.break_hours = data.break_hours;
          this.working_hours = data.working_hours;
          this.autoClockOff = data.auto_out_time;
        })
        .catch(e => {
          this.showError(e);
        });
    },
    addHoliday() {
      this.$validator.validateAll("holiday-form").then(result => {
        if (result) {
          if (this.holidayId) {
             let index = this.holidays.findIndex(
              app => app.id == this.holidayId
            );
            this.holidays[index].title = this.title;
            this.holidays[index].date = this.holidayDate;
          } else {
            this.holidays.push({
              id: this.holidays.length + 1,
              title: this.title,
              date: this.holidayDate
            });
          }
          this.holidayId = null;
          this.title = null;
          this.holidayDate = null;
          this.$validator.reset("holiday-form");
          this.errors.clear("holiday-form");
        }
      });
    },
    editHoliday(index) {
      let holidayData = this.holidays[index];
      this.holidayId = holidayData.id;
      this.title = holidayData.title;
      this.holidayDate = holidayData.date;
    },
    confirmDelete(index) {
      this.deleteIndex = index;
      // jquery call
      let text = "Are you sure you want to delete this holiday?";

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: text,
        acceptText: "Delete",
        accept: this.removeHoliday
      });
    },
    removeHoliday() {
      /*   if (this.holidays[index].id != null) {
        this.remove_holidayIds.push(this.holidays[index].id);
      } */
      this.holidays.splice(this.deleteIndex, 1);
    },
    updateLogo() {
      let input = {
        id: this.$store.state.uInfo.organization,
        logo: this.logo,
        logo_update: this.logo_update
      };
      this.axios
        .put("organization/edit", input)
        .then(response => {
          if (response.data.data) {
            let logo = response.data.data.logo;
            let userStoreInfo = this.$store.state.uInfo;

            userStoreInfo.org_image = logo;
            localStorage.setItem("user", JSON.stringify(userStoreInfo));

            this.$store.dispatch("updateUser", userStoreInfo);
            this.button_loader(false, "#org-addupdate");
            let text = "Company logo updated successfully";
            this.$vs.notify({
              text: text,
              color: "success",
              position: "top-right"
            });
            this.show_image_popup = false;
            this.getInfo();
          }
        })
        .catch(e => {
          this.showError(e, "#logo-addupdate");
        });
    }
  }
};
</script>
<style scoped>
.label {
  font-weight: 600;
  color: #666;
  padding-bottom: 5px;
  float: left;
  width: 100%;
  font-size: 12px !important;
}
</style>